import { Link } from "react-router-dom";
import { PageHero, SectionHead } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { WELFARE } from "../data/content";

export default function Welfare() {
  return (
    <>
      <PageHero eyebrow="Welfare & Benefits" title="Welfare & Empowerment" subtitle="Initiatives that support the health, financial security, growth and well-being of IT employees and their families." image="/images/coconut.jpg" testId="welfare-hero" />
      <section className="py-16 md:py-24">
        <div className="container-x">
          <SectionHead eyebrow="Our initiatives" title="Programmes for members" text="Specific programmes, eligibility and schedules are announced through the News & Activities section." />
          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {WELFARE.map(({ icon: Icon, title, text }, i) => (
              <Reveal key={title} delay={i * 0.05}>
                <div className="card-lift group h-full rounded-xl border border-slate-200 bg-white p-7" data-testid={`welfare-card-${i}`}>
                  <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-leaf-light text-leaf transition-colors group-hover:bg-leaf group-hover:text-white"><Icon className="h-6 w-6" /></span>
                  <h3 className="mt-5 font-display text-lg font-bold text-navy">{title}</h3>
                  <p className="mt-2 text-sm text-slate-600">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-14 flex flex-col items-start gap-4 rounded-2xl bg-navy p-8 text-white md:flex-row md:items-center md:justify-between">
            <p className="font-display text-xl font-bold">Become a member to take part in welfare programmes.</p>
            <div className="flex gap-3">
              <Link to="/membership" className="btn-green" data-testid="welfare-join-link">Join Now</Link>
              <Link to="/news?tab=events" className="inline-flex items-center rounded-lg border border-white/30 px-6 py-3 text-sm font-semibold hover:bg-white/10" data-testid="welfare-events-link">Upcoming events</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
